<template>
  <div id="app">
    <Flipbook class="flipbook" :pages="pages" ref="flipbook"></Flipbook>
  </div>
</template>

<script>
import Flipbook from "flipbook-vue";
export default {
  components: {
    Flipbook
  },
  data: () => {
    return {
      pages: [
        "https://coffee.alexflipnote.dev/random?asd=1",
        "https://coffee.alexflipnote.dev/random?asd=2",
        "https://coffee.alexflipnote.dev/random?asd=3",
        "https://coffee.alexflipnote.dev/random?asd=4",
        "https://coffee.alexflipnote.dev/random?asd=5",
        "https://coffee.alexflipnote.dev/random?asd=6",
        "https://coffee.alexflipnote.dev/random?asd=7",
        "https://coffee.alexflipnote.dev/random?asd=8",
        "https://coffee.alexflipnote.dev/random?asd=9",
      ],
      pagesHiRes: [
        "https://coffee.alexflipnote.dev/random?asd=1",
        "https://coffee.alexflipnote.dev/random?asd=2",
        "https://coffee.alexflipnote.dev/random?asd=3",
        "https://coffee.alexflipnote.dev/random?asd=4",
        "https://coffee.alexflipnote.dev/random?asd=5",
        "https://coffee.alexflipnote.dev/random?asd=6",
        "https://coffee.alexflipnote.dev/random?asd=7",
        "https://coffee.alexflipnote.dev/random?asd=8",
        "https://coffee.alexflipnote.dev/random?asd=9",
      ]
    };
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.flipbook {
  width: 90vw;
  height: 90vh;
}
.flipbook .bounding-box {
  box-shadow: 0 0 20px #000;
}
</style>
